import React, { useState, useEffect } from 'react';
import Sidebar from '../ui/Sidebar';
import MobileMenuButton from '../ui/MobileMenuButton';
import MobileOverlay from '../ui/MobileOverlay';
import Breadcrumb from '../ui/Breadcrumb';
import QuickActionButton from '../ui/QuickActionButton';
import NavigationSearch from '../ui/NavigationSearch';
import Icon from '../AppIcon';
import ChatbotWidget from '../ui/ChatbotWidget';


const MainLayout = ({ children }) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const handleToggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  const handleToggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleCloseMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e?.ctrlKey || e?.metaKey) && e?.key === 'k') {
        e?.preventDefault();
        setIsSearchOpen(true);
      }
      if ((e?.ctrlKey || e?.metaKey) && e?.key === 'b') {
        e?.preventDefault();
        setIsSidebarCollapsed(prev => !prev);
      }
    };

    window?.addEventListener('keydown', handleKeyDown);
    return () => window?.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <div className="hidden lg:block">
        <Sidebar
          isCollapsed={isSidebarCollapsed}
          onToggleCollapse={handleToggleSidebar}
        />
      </div>

      <div className="lg:hidden">
        <MobileMenuButton
          isOpen={isMobileMenuOpen}
          onClick={handleToggleMobileMenu}
        />
        <MobileOverlay
          isOpen={isMobileMenuOpen}
          onClick={handleCloseMobileMenu}
        />
        <div
          className={`fixed top-0 left-0 h-full z-50 transform transition-transform duration-250 ease-smooth ${
            isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'
          }`}
        >
          <Sidebar
            isCollapsed={false}
            onToggleCollapse={handleCloseMobileMenu}
            isMobile={true}
          />
        </div>
      </div>

      <main
        className={`min-h-screen transition-all duration-250 ease-smooth pt-20 lg:pt-0 ${
          isSidebarCollapsed ? 'lg:ml-20' : 'lg:ml-60'
        }`}
      >
        <div className="container mx-auto px-6 py-8 max-w-7xl">
          <div className="flex items-center justify-between mb-6">
            <Breadcrumb />
            <button
              onClick={() => setIsSearchOpen(true)}
              className="hidden lg:flex items-center gap-2 px-4 py-2 bg-muted border border-border rounded-lg hover:bg-muted/80 transition-smooth group"
            >
              <Icon name="Search" size={16} color="var(--color-muted-foreground)" />
              <span className="text-sm text-muted-foreground">Quick search...</span>
              <kbd className="ml-2 px-2 py-0.5 text-xs bg-background rounded border border-border group-hover:border-primary transition-smooth">
                Ctrl+K
              </kbd>
            </button>
          </div>
          {children}
        </div>
      </main>

      <NavigationSearch isOpen={isSearchOpen} onClose={() => setIsSearchOpen(false)} />
      <QuickActionButton />
      <ChatbotWidget />
    </div>
  );
};

export default MainLayout;